/* eslint sort-keys: "error" */
/* eslint-env es6 */
import { Themes } from '@sainsburys-tech/bolt'
import { TuVocab } from '@sainsburys-tech/bolt-vocab-provider'

const tu = {
  backInStock: {
    key: 'BACK_IN_STOCK_KEY',
    proxyPath: '/product-api/back-in-stock',
    url: 'BACK_IN_STOCK_URL_TU'
  },
  bolt: {
    namespace: 'bolt-tu'
  },
  bzKey: 'BAZAARVOICE_KEY_TU',
  canonicalBase: 'https://tuclothing.sainsburys.co.uk',
  channel: 'TU_UK',
  genai_reviews_summary: false,
  metaDescription: 'Thousands of products for next day delivery or free in store collection.',
  tealiumPath: 'argos/tuc',
  theme: Themes.TuTheme,
  vocab: TuVocab
}

const TuFeatures = {
  ASK_QUESTION: true,
  ATT_MODAL_HIDE_CATEGORIES: false,
  ATT_MODAL_HIDE_EXTRAS: false,
  BASE_URL: 'www.tuclothing.sainsburys.co.uk',
  BREADCRUMB: true,
  CATEGORY_EXPERIENCES_TEMPLATE_ENABLED: false,
  CNET: false,
  COMPARISON_ATTRIBUTES: true,
  COMPLETE_THE_LOOK: false,
  CUSTOMER_GENERATED_CONTENT: true,
  DESCRIPTION_CLASS: 'xs-12--none md-7--none xl-8--none',
  EMAIL_ME_BACK: {
    ctaText: 'Email me',
    enabled: true,
    excludedSkus: [],
    position: 'sizePicker',
    proxyPath: tu.backInStock.proxyPath,
    source: null,
    trackOnLoad: true
  },
  ENERGY_SAVING: false,
  ESSENTIAL_EXTRAS: true,
  FABLE_ATT: true,
  FEATURED_PRODUCTS: true,
  FREQUENTY_BROUHT_TOGETHER: true,
  KLARNA_CREDITPLAN: true,
  KLARNA_MESSAGING: {
    dcid:
      'klarna_live_client_eEVwUkNJKUhMMSlDSyEqMEx5ISFVMiNmWipaMkRNRlUsNDYxMjVkOWUtYjZhOS00YjU1LTkyN2EtYjJiNjZmYTI3ZDgzLDEsWWtFcjk3TWhVYWVlMVhGK1FwUElEN1hYbHRNVmtPVmxjSHVhWDJ4T0gvbz0',
    enabled: true
  },
  MEDIA_CLASS: 'xs-12--none md-7 xl-8',
  MEDIA_PORTRAIT: true,
  MONTHLY_PAYMENT_PLAN: false,
  NECTAR: true,
  PAYPAL_IFC_MESSAGING: false,
  PAYPAL_MESSAGING: true,
  PDP_V2_ENABLED: false,
  PRICING_CLASS: 'xs-12--none md-5--none xl-4--none',
  Q_AND_A: false,
  REVIEWS: true,
  REVIEWS_WRITE_REVIEW_ENABLED: false,
  SHOP_COLLECTION: false,
  SHOW_ARGOSCARD_LOGO_FINANCE_ACCORDION: false,
  SOLD_BY_ARGOS: false,
  SPECIFICATION_TABLE: false,
  STICKY_BAR: false,
  TEMPLATE_TYPE: 'TU',
  WISHLIST: false
}

export { tu }
export default TuFeatures
